/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxmUserauthV1ProgramQueryServiceProgramGetProgramGetRequest, IxmUserauthV1ProgramQueryServiceProgramGetResponse } from '@interxfi/types';

export const IXM_USERAUTH_V1_PROGRAM_QUERY_SERVICE_PROGRAM_GET_AUDIENCE = ['platform', 'organization', 'clearing', 'program'];

export async function ixmUserauthV1ProgramQueryServiceProgramGet(baseUrl: string | undefined, request?: IxmUserauthV1ProgramQueryServiceProgramGetProgramGetRequest, requestInit?: RequestInit): Promise<IxmUserauthV1ProgramQueryServiceProgramGetResponse | undefined> { return makeRequest<IxmUserauthV1ProgramQueryServiceProgramGetResponse, IxmUserauthV1ProgramQueryServiceProgramGetProgramGetRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/portal/userauth/v1/program/q/:programId', request, requestInit)); }

